import { ReactComponent as Comments } from 'assets/images/videoReactions/comments.svg';
import styled from 'styled-components/macro';

const CommentsIcon = styled(Comments)`
  width: ${props => props.width || '24px'};
  height: ${props => props.height || '24px'};
`;

export default CommentsIcon;
